import React, { useState, useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import moment from "moment";

const DobField = ({ setFormData, selectedDate2, minAge = 18, disabled }) => {
  const [selectedDate, setSelectedDate] = useState(undefined);

  useEffect(() => {
    if (selectedDate2) {
      const parsedDate = dayjs(selectedDate2, "DD-MM-YYYY");
      if (parsedDate.isValid()) {
        setSelectedDate(parsedDate);
      } else {
        setSelectedDate(undefined);
      }
    } else {
      setSelectedDate(undefined);
    }
  }, [selectedDate2]);

  const calculateAndSetAge = (dateOfBirth) => {
    if (dateOfBirth) {
      let date = moment(new Date(dateOfBirth)).format("DD-MM-YYYY");

      setFormData((prevData) => ({
        ...prevData,
        date_of_birth: date,
      }));
    }
  };

  return (
    <>
      <div className="calendar_mui">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MobileDatePicker
            views={["year", "month", "day"]}
            openTo={"year"}
            css={{ backgroundColor: "orange" }}
            onChange={(value) => {
              if (value) {
                setSelectedDate(value);
                calculateAndSetAge(value);
              } else {
                setSelectedDate(undefined);
                calculateAndSetAge(undefined);
              }
            }}
            value={selectedDate}
            format={"DD-MM-YYYY"}
            disableOpenPicker={false}
            sx={{
              "& .MuiTextField-root": {
                flex: 1,
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                  borderRadius: "8px",
                  userSelect: "none",
                },
                backgroundColor: "white",
                color: "black",
                borderRadius: "8px",
                paddingRight: "0",
                "& .MuiInputBase-input": {
                  color: "black",
                  padding: "10px",
                  userSelect: "none",
                  zIndex: 1,
                },
              },
              ".MuiPickersToolbar-root": {
                color: "#1565c0",
                borderRadius: "0px",
                borderWidth: "0px",
                borderColor: "#2196f3",
                border: "0px solid",
                backgroundColor: "#90caf9",
              },
              flex: 1,
              "& .MuiSvgIcon-root": {
                color: "black",
              },
            }}
            maxDate={dayjs().subtract(minAge, "years")}
            readOnly={disabled}
          />
        </LocalizationProvider>
      </div>
    </>
  );
};

export default DobField;
